import React from "react";
import { StopPopupLoadingSkeletonRows } from "./StopPopupLoadingSkeleton";
import { STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX } from "./stopPopup.layout.constants";

const STOP_POPUP_ARRIVALS_LIST_SCROLL_CLASS_NAME =
    "no-bounce touch-pan-y overscroll-contain [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]";

/** Shared list shell — vertical spacing lives on each row shell (`mb-1`), not flex gap. */
const STOP_POPUP_ARRIVALS_LIST_LAYOUT_CLASS_NAME =
    `flex w-full min-h-0 flex-col ${ STOP_POPUP_ARRIVALS_LIST_SCROLL_CLASS_NAME }`;

interface StopPopupArrivalsListMotionProps {

    /** Loaded arrival rows. */
    "children": React.ReactNode;

    /** Whether dark overlay palette is active. */
    "isDarkUi": boolean;

    /** Whether arrivals are still loading or deferred rows are pending. */
    "isLoading": boolean;

    /** Parent station flag for skeleton placeholders (map-click value). */
    "isParentStop": boolean;

    /** Scroll container ref for the loaded list. */
    "listRef": React.Ref<HTMLDivElement>;
}

/**
 * Shared arrivals list shell.
 * Fixed-height box; swaps skeleton placeholders for loaded rows without reveal animation.
 *
 * @param props List shell props.
 * @returns Arrivals list container.
 */
const StopPopupArrivalsListMotion: React.FC<StopPopupArrivalsListMotionProps> = ( {
    children,
    isDarkUi,
    isLoading,
    isParentStop,
    listRef,
} ) => {
    const listStyle = {
        "height":    `${ STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX }px`,
        "maxHeight": `${ STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX }px`,
    };
    const overflowClassName = isLoading
        ? "overflow-hidden"
        : "min-h-0 overflow-y-auto";

    return (
        <div
            aria-busy={isLoading}
            className={`${ STOP_POPUP_ARRIVALS_LIST_LAYOUT_CLASS_NAME } ${ overflowClassName }`}
            ref={listRef}
            style={listStyle}
        >
            {isLoading
                ? (
                    <StopPopupLoadingSkeletonRows
                        isDarkUi={isDarkUi}
                        isParentStop={isParentStop}
                    />
                )
                : children}
        </div>
    );
};

export default StopPopupArrivalsListMotion;
